import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import Select from "react-select";
import { LoadingPortContext, resolvePageAccess } from "../../context/LoadingPortContext";

import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { EditorAttachFile } from "material-ui/svg-icons";
import { Delete, Edit, Trash } from "lucide-react"
// import "./HubMaster.css";
import redirectURL from "../redirectURL.js";
// import * as XLSX from "xlsx/xlsx.mjs"; // ← ESM for browser
// import { saveAs } from "file-saver";
import SweetAlert from 'react-bootstrap-sweetalert';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { getCellValue, getUserIdentityFields } from "../common/utils";


const HubMaster = () => {
    // const location = useLocation();
    
    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    
    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);

    // ---------------- DROPDOWN ----------------
    const loadingPorts = [
        { value: "CHN", label: "Chennai" },
        { value: "MUM", label: "Mumbai" },
        { value: "KOL", label: "Kolkata" }
    ];
    var allowActionsRef = useRef(false);
    var allowDeleteRef = useRef(false);
    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        latitude: "",
        longitude: "",
        no_regular_club: 0
    });

    const [rowData, setRowData] = useState(
        // [
        //     {
        //         loading_port_code: "CHN",
        //         hub_name: "Chennai Central Hub",
        //         latitude: 13.0827,
        //         longitude: 80.2707
        //     },
        //     {
        //         loading_port_code: "MUM",
        //         hub_name: "Mumbai Distribution Hub",
        //         latitude: 19.0760,
        //         longitude: 72.8777
        //     },
        //     {
        //         loading_port_code: "KOL",
        //         hub_name: "Kolkata East Hub",
        //         latitude: 22.5726,
        //         longitude: 88.3639
        //     },
        //     {
        //         loading_port_code: "CHN",
        //         hub_name: "Sriperumbudur Hub",
        //         latitude: 12.9675,
        //         longitude: 79.9419
        //     },
        //     {
        //         loading_port_code: "MUM",
        //         hub_name: "Navi Mumbai Hub",
        //         latitude: 19.0330,
        //         longitude: 73.0297
        //     }
        // ]
    );
    const [editIndex, setEditIndex] = useState(null);
    const [originalFormData, setOriginalFormData] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);

    // const handleChange = e =>
    //     setFormData({ ...formData, [e.target.name]: e.target.value });
    const [inputErrors, setInputErrors] = useState({
        latitude: "",
        longitude: ""
    });
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Hub name edit disabled
        if (name === "hub_name" && editIndex != null) return;

        let errorMsg = "";

        // Latitude validation
        if (name === "latitude") {
            if (value === "") {
                errorMsg = "";
            } else if (!/^[-]?\d*\.?\d*$/.test(value)) {
                errorMsg = "Only numbers allowed";
            } else {
                const num = parseFloat(value);
                if (num < -90 || num > 90) {
                    errorMsg = "Latitude must be between -90 and 90";
                }
            }
        }

        // Longitude validation
        if (name === "longitude") {
            if (value === "") {
                errorMsg = "";
            } else if (!/^[-]?\d*\.?\d*$/.test(value)) {
                errorMsg = "Only numbers allowed";
            } else {
                const num = parseFloat(value);
                if (num < -180 || num > 180) {
                    errorMsg = "Longitude must be between -180 and 180";
                }
            }
        }

        // Always update input value
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Update error messages
        setInputErrors((prev) => ({ ...prev, [name]: errorMsg }));
    };
    const handlePortChange = (selected) => {
        // console.log(selected)
        setFormData({ ...formData, loading_port_code: selected.value, comp_short_name: selected.label });
    }

    // ---------------- VALIDATION ----------------
    const showValidationAlert = (message) => {
        setShow(true);
        setBasicType("warning");
        setBasicTitle(message);
    };

    const validateForm = () => {

        if (!formData.loading_port_code) {
            showValidationAlert("Select Loading Port");
            return false;
        }

        if (!formData.hub_name.trim()) {
            showValidationAlert("Enter Hub Name");
            return false;
        }

        if (!isValidNumber(formData.latitude)) {
            showValidationAlert("Latitude must be numeric");
            return false;
        }

        if (!isValidNumber(formData.longitude)) {
            showValidationAlert("Longitude must be numeric");
            return false;
        }

        return true;
    };

    // ---------------- ADD / UPDATE ----------------
    const handleAdd = async () => {
        if (!validateForm()) return;
        if (inputErrors.latitude) {
            showValidationAlert(inputErrors.latitude);
            return
        }
        if (inputErrors.longitude) {
            showValidationAlert(inputErrors.longitude);
            return
        }

        const isEdit = editIndex !== null;

        // Editing an existing hub but nothing was actually changed - skip the API call.
        if (isEdit && originalFormData &&
            String(formData.latitude) === String(originalFormData.latitude) &&
            String(formData.longitude) === String(originalFormData.longitude) &&
            (formData.no_regular_club ? 1 : 0) === (originalFormData.no_regular_club ? 1 : 0)) {
            setShow(true)
            setBasicType("warning")
            setBasicTitle("No Changes Made.")
            closeSlider();
            return;
        }

        setLoadshow("show-m")
        setOverly("show-m")
        const payload = {
            loading_port_code: formData.loading_port_code,
            comp_short_name: formData.comp_short_name,
            hub_name:
                String(formData.hub_name || "")
                    .trim()
                    .toUpperCase(),
            latitude: parseFloat(formData.latitude),
            longitude: parseFloat(formData.longitude),
            no_regular_club: formData.no_regular_club ? 1 : 0,
            is_active: 1,
            ...getUserIdentityFields()
        };
        await updateHubData([payload], isEdit ? "Updated Succesfully" : "Added Succesfully")
        await getHubData();

        closeSlider();
        setLoadshow("show-n")
        setOverly("show-n")
    };

    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({
            loading_port_code: null,
            hub_name: "",
            latitude: "",
            longitude: "",
            no_regular_club: 0
        });
        setOriginalFormData(null);
        setShowBulkSlider(false)
        setValidData([])
        setErrors([])
        setFileName("")
    };

    // ---------------- EDIT ----------------
    const handleEdit = (params) => {
        setFormData(params.data);
        setOriginalFormData(params.data);

        setEditIndex(params.rowIndex);
        setShowSlider(true);
    };

    // ---------------- DELETE ----------------

    const handleDelete = async (params) => {

        const payload = {
            loading_port_code: params.data.loading_port_code,
            hub_name: params.data.hub_name,
            is_active: 1,  // usually delete = deactivate
            ...getUserIdentityFields()
        };
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        setLoadshow("show-m")
        setOverly("show-m")
        console.log(payload);
        await deleteHubData([payload])
        await getHubData(params.data.loading_port_code);
        setLoadshow("show-n")
        setOverly("show-n")
    };



    const ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            {allowActionsRef.current && <Edit className="text-primary cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { handleEdit(props) }} />}
            {allowDeleteRef.current && <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { handleDelete(props) }} />}
        </div>
    );
    // ---------------- GRID ----------------
    const components = {
        actionRenderer: ActionRenderer
    };
    const columnDefs = [
        {
            headerName: "",
            width: 100,
            cellRenderer: "actionRenderer",
            pinned: "left",
            headerCheckboxSelection: allowDeleteRef.current ? true : false,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: allowDeleteRef.current ? true : false,
            hide: (!allowActionsRef.current && !allowDeleteRef.current)
        },
        // { headerName: "Source", field: "comp_short_name", width: 200 },
        { headerName: "Hub Name", field: "hub_name", width: 250 },
        { headerName: "Latitude", field: "latitude", width: 250 },
        { headerName: "Longitude", field: "longitude", width: 250 },
        {
            headerName: "Do Not Club With Regular",
            field: "no_regular_club",
            width: 280,
            valueGetter: (params) => (params.data && (params.data.no_regular_club == 1) ? "Yes" : "No")
        }
    ];

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            await pageAccessFn();
            // await getLoadingPortCodeData();
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);

    const getHubData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                is_active: 1
            }
            const response = await redirectURL.post("/masters/getHubMasterData", params);
            if (response.data.status == "success") {
                setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const updateHubData = async (params, successTitle = "Updated Succesfully") => {
        try {

            const response = await redirectURL.post("/masters/updateHubData", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
                setShow(true)
                setBasicType("success")
                setBasicTitle(successTitle)
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const deleteHubData = async (payload) => {
        try {

            var params = payload
            const response = await redirectURL.post("/masters/deleteHubData", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
                setShow(true)
                setBasicType("success")
                setBasicTitle("Deleted Succesfully")
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData.map((each) => {
                return (
                    {
                        ...each,
                        loading_port_code: loadingPortCode,
                        comp_short_name: loadingPortData.find((each) => each.value == loadingPortCode).label || "",
                        is_active: 1,
                        ...getUserIdentityFields()
                    }
                )
            })
            console.log(validData, finalData)

            await updateHubData(finalData, "Added Succesfully")
            await getHubData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setErrors([])
            setFileName("");
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteSelected = async (port) => {
        const confirmDelete = window.confirm(
            "Are you sure to delete this record?"
        );

        // ✅ Exit function if Cancel clicked
        if (!confirmDelete) return;
        setLoadshow("show-m")
        setOverly("show-m")
        var payload = selectedRows.map((each) => {
            return {
                loading_port_code: each.loading_port_code,
                hub_name: each.hub_name,
                is_active: 1,
                ...getUserIdentityFields()
            }
        })
        await deleteHubData(payload)
        await getHubData(port);
        setSelectedRows([])
        setLoadshow("show-n")
        setOverly("show-n")
    }
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(loadingPortData, editIndex)

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");

    const fileInputRef = useRef(null);

    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")
        setValidData([])
        setErrors([])
        setFileName("")

    }


    const pageAccessFn = useCallback(async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            await getHubData(resolved.loading_port_code);
        } catch (err) {
            console.log(err);
        }

    }, [portContext]);

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await getHubData(selectedPlant);
        setValidData([]);
        setErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        container: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer",
            width: "100%"
        })
    }

    const handleFileChange1 = (e) => {

        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet =
                workbook.Sheets[workbook.SheetNames[0]];

            const data =
                XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };
    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };

    // ================= VALIDATION =================

    const validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        const seenInFile = new Set();
        const existingHubNames = new Set(
            (rowData || []).map((each) =>
                String(each.hub_name || "").trim().toUpperCase()
            )
        );

        data.forEach((row, index) => {

            const rowNumber = index + 2; // Excel row (header = 1)

            let hubNameRaw = getCellValue(row, "Hub Name");
            let hubName = String(hubNameRaw || "")
                .trim()
                .toUpperCase();

            let latitude = getCellValue(row, "Latitude");
            let longitude = getCellValue(row, "Longitude");

            let rowErrors = [];

            // ---- Hub Name ----
            if (!hubName) {
                rowErrors.push("Hub Name is empty");
            } else if (existingHubNames.has(hubName)) {
                rowErrors.push(`Hub Name "${hubNameRaw}" already exists`);
            } else if (seenInFile.has(hubName)) {
                rowErrors.push(`Duplicate Hub Name "${hubNameRaw}" in uploaded file`);
            }

            // ---- Latitude ----
            if (
                latitude === "" ||
                !isValidNumber(latitude)
            ) {
                rowErrors.push(
                    `Invalid Latitude (${latitude})`
                );
            } else if (parseFloat(latitude) < -90 || parseFloat(latitude) > 90) {
                rowErrors.push(
                    `Latitude must be between -90 and 90 (${latitude})`
                );
            }

            // ---- Longitude ----
            if (
                longitude === "" ||
                !isValidNumber(longitude)
            ) {
                rowErrors.push(
                    `Invalid Longitude (${longitude})`
                );
            } else if (parseFloat(longitude) < -180 || parseFloat(longitude) > 180) {
                rowErrors.push(
                    `Longitude must be between -180 and 180 (${longitude})`
                );
            }

            // ---- Collect Errors ----
            if (rowErrors.length > 0) {
                errorList.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {
                seenInFile.add(hubName);
                var noClubRaw = String(getCellValue(row, "Do Not Club With Regular") || getCellValue(row, "Do Not Club") || "").trim().toUpperCase();
                var noClub = (noClubRaw === "1" || noClubRaw === "YES" || noClubRaw === "Y" || noClubRaw === "TRUE") ? 1 : 0;
                cleanedData.push({
                    hub_name: hubName,
                    latitude: parseFloat(latitude),
                    longitude: parseFloat(longitude),
                    no_regular_club: noClub
                });
            }
        });

        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. all fields are empty"]
            });
        }

        setErrors(errorList);
        setValidData(cleanedData);

        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };

    const isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };
    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = validData.length == 0
    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    const closeAlert = () => {
        setShow(false)
    }
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const onExportClick = () => {
        if (gridRef.current && gridRef.current.api) {
            // this.gridRef.current.api.exportDataAsCsv();
            gridRef.current.api.exportDataAsExcel({
                fileName: "hub_master.xlsx"
            });
        }
    };

    if (pageAccess != 2) {
        allowActionsRef.current = true;
    }
    if (pageAccess == 3) {
        allowDeleteRef.current = true;
    }
    return (
        <div className="hub-master-container d-flex flex-column" style={{ height: "100%", overflowY: "auto" }}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                styles={{ zIndex: "10000001" }}
            >
            </SweetAlert>
            {/* HEADER */}
            <div className="master-header">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Hub Master</h5>
                </div>

                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    {(selectedRows.length > 0 && allowDeleteRef.current) && <button
                        className="pill-btn pill-btn-danger"
                        onClick={() => { handleDeleteSelected(loadingPortCode) }}
                        disabled={selectedRows.length == 0}
                    >
                        Delete Selected
                    </button>}
                    <button
                        className="pill-btn pill-btn-primary"
                        onClick={() => { onExportClick() }}
                    >
                        Export Data
                    </button>
                    {allowActionsRef.current && <button
                        className="pill-btn pill-btn-success"
                        onClick={() => {
                            setShowSlider(true);
                            var object = loadingPortData.find((each) => each.value == loadingPortCode)
                            setFormData((prevState) => ({
                                ...prevState,
                                loading_port_code: object.value, comp_short_name: object.label
                            }))
                        }}
                    >
                        + Add
                    </button>}
                    {allowActionsRef.current && <button
                        className="pill-btn pill-btn-info"
                        onClick={() => {
                            setErrors([]);
                            setValidData([]);
                            setFileName("");
                            setShowBulkSlider(true);
                        }}
                    >
                        Import Data
                    </button>}
                </div>
            </div>



            {/* GRID */}
            <div className="ag-theme-balham grid-wrapper mt-2" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={gridRef}
                    modules={modules}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}
                    statusBar={{

                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "center" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    sideBar={{
                        toolPanels: [
                            {
                                id: 'columns',
                                labelDefault: 'Columns',
                                iconKey: 'columns',
                                toolPanel: 'agColumnsToolPanel'
                            },
                            {
                                id: 'filters',
                                labelDefault: 'Filters',
                                iconKey: 'filter',
                                toolPanel: 'agFiltersToolPanel'
                            }
                        ],
                        // defaultToolPanel: 'filters'

                    }}
                    animateRows rowSelection={"multiple"}
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }} suppressRowClickSelection={true}
                />
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}

            {/* RIGHT SLIDER */}
            <div className={`hub-slider ${showSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    {editIndex !== null ? "Edit Hub" : "Add Hub"}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 pt-4">

                    <label className="m-0">Loading Plant<span className="text-danger">*</span></label>
                    <Select
                        options={loadingPortData}
                        value={loadingPortData.find((each) => each.value == formData.loading_port_code)}
                        onChange={handlePortChange}
                        classNamePrefix="react-select" className="mb-2"
                        isDisabled={true}
                        styles={customStyles}
                    />

                    <label className="m-0">Hub Name<span className="text-danger">*</span></label>
                    <input
                        name="hub_name"
                        value={formData.hub_name}
                        onChange={handleChange} className="mb-2" disabled={editIndex != null}
                        style={{ cursor: editIndex != null && "not-allowed" }}
                    />

                    <label className="m-0">Latitude<span className="text-danger">*</span></label>
                    <input
                        name="latitude"
                        value={formData.latitude}
                        onChange={handleChange} className="mb-2"
                    />
                    <label className="m-0 text-danger">{inputErrors.latitude}</label>
                    {/* {inputErrors.latitude && <div className="text-danger bg-primary">{errors.latitude}</div>} */}


                    <label className="m-0">Longitude<span className="text-danger">*</span></label>
                    <input
                        name="longitude"
                        value={formData.longitude}
                        onChange={handleChange}
                    />
                    <label className="m-0 text-danger">{inputErrors.longitude}</label>
                    {/* {inputErrors.longitude && <div className="text-danger">{errors.longitude}</div>} */}

                    <label className="m-0 mt-3" style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                        <input
                            type="checkbox"
                            name="no_regular_club"
                            checked={formData.no_regular_club == 1}
                            onChange={(e) => { const checked = e.target.checked; setFormData((prev) => ({ ...prev, no_regular_club: checked ? 1 : 0 })); }}
                            style={{ width: "16px", height: "16px", cursor: "pointer" }}
                        />
                        <span>Do not club with regular trucks</span>
                    </label>
                    <div className="m-0" style={{ fontSize: "11px", color: "#999" }}>
                        When enabled, this hub's unserved loads are held as HUB HOLD instead of being clubbed with regular trucks.
                    </div>

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px" }}
                        onClick={handleAdd}
                    >
                        {editIndex !== null ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Import Data
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1">

                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <a href={require("../../assets/hub_bulk_upload_template.csv")} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                            Download Sample Template
                        </a>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}

                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                    <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Submit only valid data" : "Submit"}
                    </button>
                </div>

            </div>


            <div className={"dataLoadpageimg " + (loadshow)} style={{ zIndex: 100 }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>


        </div>
    );
};

export default HubMaster;

// const DownloadHubTemplate = () => {
//   const handleDownload = () => {
//     const data = [
//       {
//         loading_port_code: "CHN",
//         hub_name: "Chennai Hub",
//         comp_short_name: "MSIL",
//         latitude: 13.0827,
//         longitude: 80.2707,
//         is_active: 1
//       }
//     ];

//     const ws = XLSX.utils.json_to_sheet(data, {
//       header: [
//         "loading_port_code",
//         "hub_name",
//         "comp_short_name",
//         "latitude",
//         "longitude",
//         "is_active"
//       ]
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Hub Upload Template");

//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, "Hub_Bulk_Upload_Template.xlsx");
//   };

//   return <button onClick={handleDownload}>Download Hub Template</button>;
// };